<script setup lang="ts">
import { capitalizeFirstLetter, date, euro } from '@/helpers';
import type { Book } from '@/types/book';
import { computed } from 'vue';

const props = defineProps<{
  step: number;
  booking: Book | null;
}>();

const persons = computed<number>(() => {
  if (!props.booking) return 0;
  const { adults, children } = props.booking.pricing.persons;
  return parseInt(adults) + parseInt(children);
});

const allTravelers = computed<number[]>(() => Array.from({ length: (Number(props.booking?.pricing?.persons?.adults ?? 0)) + (Number(props.booking?.pricing?.persons?.children ?? 0)) }, (_, i) => i))
</script>

<template>
  <div class="block block--overview">
    <img
      src="https://sneeuwzekerdeals.kinsta.cloud/wp-content/themes/szd2018/assets/images/hero/hero-img_2.jpg"
      alt=""
      class="block__img"
    />
    <div class="block__content">
      <h3 class="block__title">Prijsinformatie</h3>
      <ul>
        <li>
          <span>Vertrekdatum</span>
          <span>{{ booking ? date.format(new Date(booking?.pricing.startdate)) : '-' }}</span>
        </li>
        <li>
          <span>Reisduur</span>
          <span>{{ booking?.pricing.duration }} nachten</span>
        </li>
        <li>
          <span>Aantal personen</span>
          <span>{{ persons }} personen</span>
        </li>
      </ul>
      <hr />
      <template v-if="step === 1">
        <ul>
          <li>
            <span>Vlucht</span>
            <span>Inclusief</span>
          </li>
          <li>
            <span>Accommodatie</span>
            <span>{{ capitalizeFirstLetter(booking?.accommodation.name ?? '') }}</span>
          </li>
          <li >
            <span>Transfer</span>
            <span>{{ booking?.pricing.transfer === true ? 'Inclusief' : 'Exclusief' }}</span>
          </li>
          <li >
            <span>Skipas</span>
            <span>{{ booking?.pricing.skipass_id !== null ? 'Inclusief' : 'Exclusief' }}</span>
          </li>
          <li>
            <span>Gratis eigen ski's mee</span>
            <span>Inclusief</span>
          </li>
        </ul>
        <hr />
      </template>
      <ul>
        <template v-for="(traveler, index) in allTravelers" :key="index.toString()">
          <li>
            <span>Pakketprijs reiziger {{ index +1 }}</span>
            <span>{{ booking?.pricing.price ? euro.format(booking?.pricing.price.perperson.amount) : '-' }}</span>
          </li>
        </template>
      </ul>
      <p class="block__text">       
        De prijs is inclusief SGR bijdrage (à €5 p.p.) en Calamiteitenfonds (à €2,50 per boeking). Alle acties, aanbiedingen en kortingen zijn verwerkt in de
        totaalprijs.
      </p>
      <hr />
      <p class="block__price">
        <span>Totaalprijs</span>
        <span>{{ booking?.pricing.price ? euro.format(booking?.pricing.price.total.amount) : '-' }}</span>
      </p>
    </div>
  </div>
</template>

<style scoped></style>
